import React, { useState } from "react";
import { Table, Form } from "react-bootstrap";

// Entry point component
const UseFormTable = (props) => {
  // Initialize default data as an array of objects based on columns

  return <EditableTable {...props} />;
};

// Main table component
const EditableTable = ({
  columns,
  defaultData,
  title,
  bottomTotal,
  rightTotal,
  typeOntheBasisOfDefaultData,
}) => {
  const [data, setData] = useState(defaultData);

  // Handle input change in the form fields
  const handleInputChange = (rowIndex, columnId, inputValue) => {
    const newData = data.map((row, index) => {
      if (index === rowIndex) {
        const type = typeOntheBasisOfDefaultData
          ? defaultData[rowIndex].type
          : columns.find((column) => column.id === columnId).type || "text";

        const value = type === "number" ? parseFloat(inputValue) || 0 : inputValue;
        return { ...row, [columnId]: value };
      }
      return row;
    });

    setData(newData);
  };

  const sumColumn = (columnId) => {
    return data
      .reduce((total, row) => {
        const value = typeof row[columnId] === "number" ? parseFloat(row[columnId]) || 0 : 0;
        return total + value;
      }, 0)
      .toFixed(2);
  };

  // Calculate the total for a row
  const calculateRowTotal = (rowIndex) => {
    const row = data[rowIndex];
    return columns
      .reduce((total, { id }) => {
        const value = parseFloat(row[id]) || 0;
        return total + value;
      }, 0)
      .toFixed(2);
  };

  return (
    <Table bordered>
      <thead>
        <tr>
          {title?.length ? <th>{title}</th> : null}
          {columns?.map((column) => (
            <th key={column.id}>{column.label}</th>
          ))}
          {rightTotal && <th>Total</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {title?.length ? <td>{row.label}</td> : null}
            {/* Use the label from the row data */}
            {columns?.map((column) => (
              <td key={column.id}>
                <Form.Control
                  type={
                    typeOntheBasisOfDefaultData
                      ? defaultData?.[rowIndex]?.type
                      : column?.type || "text"
                  }
                  value={row[column.id]}
                  onChange={(e) =>
                    handleInputChange(rowIndex, column.id, e.target.value)
                  }
                />
              </td>
            ))}
            {rightTotal && <td>{calculateRowTotal(rowIndex)}</td>}
          </tr>
        ))}
      </tbody>
      {bottomTotal && (
        <tfoot>
          <tr>
            <td>Total</td>
            {columns?.map((column) => (
              <td key={column.id}>{sumColumn(column.id)}</td>
            ))}
            {rightTotal && (
              <td>
                {columns
                  ?.reduce(
                    (total, column) => total + parseFloat(sumColumn(column.id)),
                    0
                  )
                  .toFixed(2)}
              </td>
            )}
          </tr>
        </tfoot>
      )}
    </Table>
  );
};

export default UseFormTable;
